import Cookies from "js-cookie"

export const loggingOut = () => {
  localStorage.removeItem("isAdmin")
  localStorage.removeItem("isLogin")
  localStorage.removeItem("isSuperAdmin")
  Cookies.remove("keystonejs-session")
}
